import React, { useState } from 'react';
import { Box, Button, Icons, Text } from '@/theme/index';
import { ApiKey } from '../ApiKey/ApiKey';
import { NewApiKeyModal } from '../NewApiKeyModal/NewApiKeyModal';
import { useApiKeys } from '../hooks/useApiKeys/useApiKeys';

export function ApiKeysList() {
  const [newKeyModalOpen, setNewKeyModalOpen] = useState(false);
  const [newKey, setNewKey] = useState('');
  const { data: currentApiKeys, isLoading, createApiKey } = useApiKeys();
  const apiKeys = currentApiKeys?.apiKeys;

  const handleClick = async () => {
    const newKey = await createApiKey.mutateAsync();
    if (newKey.apiKey.secretKey) {
      setNewKey(newKey.apiKey.secretKey);
      setNewKeyModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setNewKeyModalOpen(false);
    setNewKey('');
  };

  return (
    <Box>
      <Box sx={{ borderBottom: '1px solid black' }}>
        <Text variant="h3">API Keys</Text>
      </Box>
      {isLoading ? (
        <Text>Loading...</Text>
      ) : (
        apiKeys?.map((apiKey) => <ApiKey apiKey={apiKey} />)
      )}
      <Button sx={{ paddingLeft: 0 }} onClick={handleClick}>
        <Icons.Add color="primary" />
        <Text color="primary">Add a key</Text>
      </Button>
      <NewApiKeyModal
        open={newKeyModalOpen}
        handleClose={handleModalClose}
        keyId={newKey}
      />
    </Box>
  );
}
